import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PauseIcon: React.FC<IconProps> = ({ fillColor, width = 24, height = 24, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 14L7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6L9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M11 14L11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6L13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { PauseIcon };
